function isShouldGetUnapprovedUsers({ state, output }) {
  if (state.get('users.unapproved')) {
    output.false()
  } else {
    output.true()
  }
}
isShouldGetUnapprovedUsers.outputs = ['true', 'false']

export default isShouldGetUnapprovedUsers



// WEBPACK FOOTER //
// ./src/modules/login/actions/isShouldGetUnapprovedUsers.js